import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ShieldCheck } from "lucide-react";
import { BRAND, CONTACT } from "@/lib/brand";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-slate-50 border-t border-slate-200"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14 sm:py-16">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <Link to="/" data-testid="footer-logo-link">
              <img
                src={BRAND.wordmark}
                alt="Clean Me"
                className="h-20 w-auto"
              />
            </Link>
            <p className="mt-5 text-slate-600 max-w-md leading-relaxed">
              Reliable commercial cleaning for offices, gyms, retail spaces and
              schools across Cork. Local team. Flexible schedules. Fully
              insured.
            </p>
            <div className="mt-5 inline-flex items-center gap-2 rounded-full bg-white border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-700">
              <ShieldCheck className="h-3.5 w-3.5 text-[#4CAF50]" />
              Fully insured Cork-based team
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display font-semibold text-slate-900 mb-4">
              Sitemap
            </h4>
            <ul className="space-y-2.5 text-slate-600">
              <li>
                <Link
                  to="/"
                  data-testid="footer-link-home"
                  className="hover:text-slate-900"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  data-testid="footer-link-services"
                  className="hover:text-slate-900"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  data-testid="footer-link-contact"
                  className="hover:text-slate-900"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-display font-semibold text-slate-900 mb-4">
              Get in touch
            </h4>
            <ul className="space-y-3 text-slate-700">
              <li>
                <a
                  href={`tel:${CONTACT.phoneTel}`}
                  data-testid="footer-phone"
                  className="inline-flex items-center gap-3 hover:text-slate-900"
                >
                  <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#4CAF50]/10 text-[#388E3C]">
                    <Phone className="h-4 w-4" />
                  </span>
                  {CONTACT.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="footer-email"
                  className="inline-flex items-center gap-3 hover:text-slate-900 break-all"
                >
                  <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#4CAF50]/10 text-[#388E3C]">
                    <Mail className="h-4 w-4" />
                  </span>
                  {CONTACT.email}
                </a>
              </li>
              <li className="inline-flex items-center gap-3">
                <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#4CAF50]/10 text-[#388E3C]">
                  <MapPin className="h-4 w-4" />
                </span>
                {CONTACT.location}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-sm text-slate-500">
          <p>© {new Date().getFullYear()} Clean Me. All rights reserved.</p>
          <p>cleanme.ie · Cork, Ireland</p>
        </div>
      </div>
    </footer>
  );
}
